import { adminApi } from './api';

/* ==========================================
    그룹 관리 (Group Management)
========================================== */

/**
 * 그룹 목록 조회 (검색 및 페이징)
 * @param {Object} params - { pageNum, pageSize, search, sort, examFirst }
 * Note: pageNum은 1부터 시작
 */
export const fetchGroupList = async (params) => {
    // params: { pageNum: 1, pageSize: 20, search: '', sort: '', examFirst: false }
    const response = await adminApi.get(`/api/admin/groups`, { params });
    return response.data.data;
};

/* 그룹 상세 조회 */
export const fetchGroupDetail = async (groupId) => {
    const response = await adminApi.get(`/api/admin/groups/${groupId}`);
    return response.data.data;
};

/* 그룹 생성 */
export const createGroup = async (groupData) => {
    // groupData: { groupName, groupCourse, groupCourseCount, groupStartDate, groupDueDate, groupStatus, groupAssessId, courseIds, completionRequirements}
    const response = await adminApi.post(`/api/admin/groups`, groupData);
    return response.data.data;
};

/* 그룹 수정 */
export const updateGroup = async (groupData) => {
    // groupData: { groupId, ...나머지 필드 }
    const response = await adminApi.put(`/api/admin/groups`, groupData);
    return response.data.data;
};

/* 그룹 상태 변경 */
export const updateGroupStatus = async (groupId, groupStatus) => {
    // groupStatus: 0, 1
    const response = await adminApi.patch(`/api/admin/groups/status`, { groupId, groupStatus });
    return response.data.data;
};

/* 그룹 삭제 */
export const deleteGroup = async (groupId) => {
    const response = await adminApi.delete(`/api/admin/groups/${groupId}`);
    return response.data.data;
};

/* 해당 그룹에 매핑된 퍼실리테이터(FT)와 운영자(OP) 목록을 조회 */
export const getManagersByGroupId = async (groupId) => {
    const response = await adminApi.get(`/api/admin/groups/${groupId}/managers`);
    return response.data.data;
};

/* 그룹에 FT/OP 추가 */
export const addManagerToGroup = async (groupId, userId) => {
    const response = await adminApi.post(`/api/admin/groups/${groupId}/managers/${userId}`);
    return response.data.data;
};

/* 그룹에서 FT/OP 제거 */
export const removeManagerFromGroup = async (groupId, userId) => {
    const response = await adminApi.delete(`/api/admin/groups/${groupId}/managers/${userId}`);
    return response.data.data;
};